(function () {
  function init() {
    var bars = document.querySelectorAll('[data-laudace-sticky-atc]');
    if (!bars.length || !('IntersectionObserver' in window)) return;

    bars.forEach(function (bar) {
      var mediaId = bar.getAttribute('data-media-target');
      var media = mediaId ? document.getElementById(mediaId) : null;
      if (!media) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('laudace-sticky-atc--visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px' }
      );

      observer.observe(media);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
